module.exports = __webpack_public_path__ + "img/BondLogix_Stacked.31a322d6.png";